import { Row, Container,Button } from 'react-bootstrap';
import Styles from './healthpage.module.scss';
import aboutUsImage from '../../../assets/health1.webp';
import logo from '../../../assets/health2.webp';
import pic1 from '../../../assets/winter.webp';
import pic2 from '../../../assets/fall.webp';
import pic3 from '../../../assets/air.webp';
import pic4 from '../../../assets/decision.webp';
import pic5 from '../../../assets/early.webp';
import pic6 from '../../../assets/cleaning.webp';
import logo1 from '../../../assets/health3.webp';

const Healthpage = () => {
	return (
		<div className={Styles.container}>
			<Row className={Styles.header}>
				<div className={Styles.slogan}>
					<h1>Nurture Wellness, Ensure Safety</h1>
				</div>
				<div className={Styles.aboutUsImage}>
					<img src={aboutUsImage} alt="about us" rel='preload'/>
				</div>
			</Row>
			<div className={Styles.cont}>
				<h1>Common health risks associated with poor air quality</h1>
				<Row className={Styles.founder}>
					<div className={Styles.logo}><img src={logo} alt="" /></div>
					<div className={Styles.text}>
					<p>You’re always breathing, so poor air quality can impact your overall health and well-being.</p>
					<ul>
						<li>Respiratory conditions like asthma, bronchitis, and respiratory infections (common cold, pneumonia) can be triggered or worsened.</li>
						<li>Cardiovascular concerns, such as heart disease, heart attack, stroke, and high blood pressure, increase where there is poor air quality.</li>
						<li>Allergy symptoms can worsen, including irritation or discomfort of your eyes, nose, and throat.</li>
						<li>Increased risk of cancer is linked to prolonged exposure to certain pollutants.</li>
					</ul>
					</div>
				</Row>

				<h1>Steps to protect yourself when air quality is unhealthy</h1>
				<Row className={Styles.founder}>
					<div className={Styles.logo1}><img src={logo1} alt="" /></div>
					<div className={Styles.text}>
					<p>Follow these steps to protect you and your family during poor air quality.</p>
					<ul>
						<li>Avoid outdoor activities.</li>
						<li>Do not smoke.</li>
						<li>Exercise indoors to improve lung health.</li>
						<li>Follow medical advice and treatment plans for pre-existing conditions.</li>
						<li>Maintain a clean indoor environment by closing windows, using air purifiers, and ensuring proper ventilation.</li>
						<li>Stay informed about local air quality reports and forecasts.</li>
						<li>Use personal protective equipment like N95 masks when necessary.</li>
					</ul>
					</div>
				</Row>
				
				<div className={Styles.faculty}>
					<h1>Delve into Enlightening Articles</h1>
					
					<Row className={Styles.pictures}>
						<div className={Styles.pic}>
							<img src={pic1} alt="" />
							<h3>What causes winter allergies and how to prevent them </h3>
							<a href="https://www.medicalnewstoday.com/articles/winter-allergies" target="_blank"> <Button variant="secondary" className={Styles.informationSecButton}>
							Read More
							</Button>
						</a>
						</div>
						<div className={Styles.pic}>
							<img src={pic2} alt="" />
							<h3>5 Fall air quality concerns you need to know</h3>
							<a href="https://www.iqair.com/newsroom/fall-air-quality" target="_blank"> <Button variant="secondary" className={Styles.informationSecButton}>
							Read More
							</Button>
						</a>
						</div>
						<div className={Styles.pic}>
							<img src={pic3} alt="" />
							<h3>Air pollution: The invisible health threat</h3>
							<a href="https://www.who.int/news-room/feature-stories/detail/air-pollution--the-invisible-health-threat" target="_blank"> <Button variant="secondary" className={Styles.informationSecButton}>
							Read More
							</Button>
						</a>
						</div>
					</Row>
					<Row className={Styles.pictures}>
					<div className={Styles.pic}>
							<img src={pic4} alt="" />
							<h3>How important is air quality in travel decision-making?</h3>
							<a href="https://www.sciencedirect.com/science/article/abs/pii/S2213078021000165" target="_blank"> <Button variant="secondary" className={Styles.informationSecButton}>
							Read More
							</Button>
						</a>
						</div>
						<div className={Styles.pic}>
							<img src={pic5} alt="" />
							<h3>Monitoring air pollution: Use of early warning systems for public health</h3>
							<a href="https://onlinelibrary.wiley.com/doi/full/10.1111/j.1440-1843.2011.02065.x" target="_blank"> <Button variant="secondary" className={Styles.informationSecButton}>
							Read More
							</Button>
						</a>
						</div>
						<div className={Styles.pic}>
							<img src={pic6} alt="" />
							<h3>Cleaning tips for a healthier home</h3>
							<a href="https://www.tandfonline.com/doi/abs/10.1080/07341519808581936" target="_blank"> <Button variant="secondary" className={Styles.informationSecButton}>
							Read More
							</Button>
						</a>
						</div>
						</Row>


				</div>
			</div>
		</div>
	);
};
export { Healthpage };
